export const SDK_VERSION = '7.29.0';



// WEBPACK FOOTER //
// ../../src/version.ts